import { List } from "semantic-ui-react";

import type { CheckInService, Tag } from "models";

type LocationServiceItemProps = {
  tags: Tag[];
  service: CheckInService;
  onClick: (service: CheckInService) => void;
};

export const LocationServiceItem = ({ service, tags, onClick }: LocationServiceItemProps) => {
  const tag = tags.find(t => t.id === service.tag_id);

  return (
    <List.Item className="Service" onClick={() => onClick(service)}>
      <List.Content>
        <div className="service-name-tag">
          <span>{service.name}</span>
          {tag && (
            <span className="service-tag" style={{ backgroundColor: tag.color }}>
              {tag.name}
            </span>
          )}
        </div>
        <div className="service-price">{service.price}</div>
      </List.Content>
    </List.Item>
  );
};
